import React, { useState, useEffect } from 'react'
import useSWR from 'swr'
import fetcher from '@lib/fetcher'
import OpeningStatus from './opening-status'
import InstancesList from './instances-list'

const KioskDisplay = ({ placeName, testDate, simulatedNow }) => {
  console.log('KioskDisplay props:', { placeName, testDate, simulatedNow })

  // Calculate time offset if using test mode
  const initialSimulatedTime = new Date(simulatedNow || new Date())
  const initialRealTime = new Date()
  const timeOffset = initialSimulatedTime - initialRealTime

  const [currentTime, setCurrentTime] = useState(initialSimulatedTime)

  // Parse the test date to format it for API calls
  const displayDate = testDate || new Date().toISOString().split('T')[0]

  // Fetch opening times data
  const { data: openingTimes, error: openingError } = useSWR(
    `/opening_times/${displayDate}`,
    fetcher,
    {
      refreshInterval: 30000 // Refresh every 30 seconds
    }
  )

  // Fetch instances for the date
  const { data: instances, error: instancesError, isLoading: instancesLoading } = useSWR(
    `/whatson/${displayDate}`,
    fetcher,
    {
      refreshInterval: 30000 // Refresh every 30 seconds
    }
  )

  // Update current time every second, maintaining test date offset if present
  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date()
      const adjustedTime = new Date(now.getTime() + timeOffset)
      setCurrentTime(adjustedTime)
    }, 1000)

    return () => clearInterval(timer)
  }, [timeOffset])

  // Filter instances to only show from active venues (keep all time periods)
  const filteredInstances = instances?.filter(instance => {
    return instance.venue?.active !== false
  }) || []

  // Loading state
  if (!openingTimes && !instances) {
    return (
      <div className="h-full flex items-center justify-center">
        <div className="text-4xl text-gray-400">Loading...</div>
      </div>
    )
  }

  // Error state
  if (openingError || instancesError) {
    return (
      <div className="h-full flex items-center justify-center">
        <div className="text-4xl text-red-500">Error loading data</div>
      </div>
    )
  }

  return (
    <div className="h-full flex flex-col bg-black text-white">
      {/* Opening status strip */}
      <div className="border-b border-gray-700">
        <OpeningStatus
          placeName={placeName}
          openingTimes={openingTimes}
          currentTime={currentTime}
        />
      </div>

      {/* Instances list */}
      <div className="flex-1 overflow-y-auto">
        <InstancesList
          instances={filteredInstances}
          currentTime={currentTime}
          isLoading={instancesLoading}
        />
      </div>
    </div>
  )
}

export default KioskDisplay
